import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcMap(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.75 6.525v12.404l4-1.455V5.07zm5.5 10.95 4 1.454V6.526l-4-1.455zm5.5-10.968v12.385l3.5-1.4V5.108zm5 11.154c0 .511-.312.972-.786 1.162l-4.686 1.874a.75.75 0 0 1-.534.008L9.5 18.798l-4.572 1.663a1.25 1.25 0 0 1-1.677-1.175V6.351c0-.526.33-.995.823-1.175l5.171-1.88.126-.034a.75.75 0 0 1 .386.033l5.231 1.902 4.05-1.619.153-.05a1.25 1.25 0 0 1 1.56 1.21z"
  }));
}
var IcMap = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMap));

export { IcMap as I };
